import { Component, ViewChild, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Chart } from 'chart.js';
import { Cliente } from '../models/Cliente';
import { ClienteService } from '../services/cliente.service';
import { DocumentoService } from '../services/documento.service';
import { LicenciaService } from '../services/licencia.service';
import { LoginService } from '../services/login.service';



@Component({
  selector: 'app-my-doughnut-chart',
  templateUrl: './my-doughnut-chart.component.html',
  styleUrls: ['./my-doughnut-chart.component.scss']
})
export class MyDoughnutChartComponent implements OnInit {

  @ViewChild('doughnutCanvas') doughnutCanvas: any;

  title: any;
  barChart: any;
  doughnutChart: any;
  lineChart: any;
  userLog: any
  documentos: any = []
  totalLicencias:any
  

  constructor(
    private loginService: LoginService, 
    private documentoService: DocumentoService, 
    private apollo: Apollo, 
    private clienteService: ClienteService,
    private licenciaService: LicenciaService) {
    this.userLog = loginService.getUserData()
 
    this.title = `${this.userLog.username}, te damos la bienvenida a Xtensa`
  }

  ngOnInit(): void {
    this.getAllDocumentos()
    setTimeout(() => {
      this.setIndicadores()
    }, 3000);
    this.getLicenciasByCliente()
  }

  ngAfterViewInit() {
    
   
    
  }

 
  
  getAllDocumentos() {
    this.apollo.watchQuery<any>({
      query: this.documentoService.getAllDocumentos(),
      fetchPolicy: 'no-cache',
    })
      .valueChanges
      .subscribe(({ data, loading, errors }) => {
        this.documentos = data.documentos
    

      })
  }

  setIndicadores() {

    this.setDocumentoProximoCaduca()
    this.setDocumentoCaducado()
    this.setDocumentoEnFecha()


  }

  setDocumentoProximoCaduca() {
    this.documentos.map((documento: any) => {
    
      if (documento?.fechaCaducidad <= this.documentoService.getNextMonth() && documento?.fechaCaducidad > this.documentoService.getActualDate() && documento.fechaCheck != this.documentoService.getActualDate()) {
        this.updateDocumentoToProximoCaduca(documento?.id)
      }
    })
  }



  updateDocumentoToProximoCaduca(id: string) {
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id,
          },
          "data": {
            "proximoCaduca": true,
            "caducado": false,
            "enFecha": false,
            "estado": "amarillo",
            "fechaCheck": this.documentoService.getActualDate()
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

  setDocumentoCaducado() {
    this.documentos.map((documento: any) => {
      if (documento.fechaCaducidad <= this.documentoService.getActualDate() && documento.fechaCheck != this.documentoService.getActualDate()) {
        this.updateDocumentoToCaducado(documento.id)
      }
    })
  }

  updateDocumentoToCaducado(id: string) {
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "caducado": true,
            "proximoCaduca": false,
            "enFecha": false,
            "estado": "rojo",
            "fechaCheck": this.documentoService.getActualDate()
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log(error)
      })
  }

  setDocumentoEnFecha() {
    this.documentos.map((documento: any) => {
      if (documento.fechaCaducidad > this.documentoService.getNextMonth() && documento.fechaCaducidad > this.documentoService.getActualDate() && documento.fechaCheck != this.documentoService.getActualDate()) {
        this.updateDocumentoToEnFecha(documento.id)
      } 
      if (documento.noCaduca && documento.fechaCheck != this.documentoService.getActualDate()) {
        this.updateDocumentoToEnFecha(documento.id)
      }
    })
  }

  updateDocumentoToEnFecha(id: string) {
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "caducado": false,
            "proximoCaduca": false,
            "enFecha": true,
            "estado": "verde",
            "fechaCheck": this.documentoService.getActualDate()
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

  getLicenciasByCliente(){
    this.apollo.watchQuery<any>({
      query: this.licenciaService.getLicenciasByCliente(),
      variables: {
        "id": this.userLog.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
      
      
       this.totalLicencias = data.cliente.licencias.length
    
       
        const licenciasActivas = data.cliente.licencias.filter((licencia:any)=>licencia.licenciaActiva)
        const licenciasNoActivas = data.cliente.licencias.filter((licencia:any)=>licencia.licenciaActiva == false)
  
        
        this.doughnutChartMethod(licenciasActivas, licenciasNoActivas)
          }
      )
  }

  doughnutChartMethod(activas:any, noActivas:any) {
    const data = [activas.length, noActivas.length]
   
    this.doughnutChart = new Chart(this.doughnutCanvas.nativeElement, {
      type: 'doughnut',
      options: {
        rotation: 1 * Math.PI,
        circumference: 1 * Math.PI
      },
      data: {
        labels: ['Licencias activas', 'Licencias NO activas'],
        datasets: [{
          label: 'licencias',
          data: data,
          backgroundColor: [
            '#1f775a',
            '#dc3737'
          ],
          hoverBackgroundColor: [
            '#308F70',
            '#f06868'
          ]
        }]
      }
    });
  }

  
}
